import { message } from "antd";
import zhCN from "@/locale/zh-CN.messages";
import esES from "@/locale/es-ES.messages";
import enUS from "@/locale/en-US.messages";


const FetchHandler = async (fetchName, params, flag) => {
  
  try {
    // console.log(
    //   "FetchHandler",
    //   "token:",
    //   window.sessionStorage.getItem("token"),
    //   "omc-token:",
    //   window.sessionStorage.getItem("omc-token"),
    //   // "menulist:",
    //   // window.sessionStorage.getItem("menulist"),
    // );
    const localeValue = window.sessionStorage.getItem("locale");
    let messageInfo = null;
    if (localeValue === "zh") {
      messageInfo = zhCN.fetchHandler;
    } else if (localeValue === "es") {
      messageInfo = esES.fetchHandler;
    } else {
      messageInfo = enUS.fetchHandler;
    }
    const resultData = await fetchName(params, localeValue);
    // console.log("resultData:", resultData);
    if (resultData.data) {
      // console.log("aaa");
      if (resultData.data.code.toString() === "200" || resultData.data.code.toString() === "304") {
        // console.log("mmm");
        if (resultData.data.text) {
          message.success(resultData.data.text, 1);
        }
        return {
          code: "success",
          data: resultData.data.data,
          pageLimit: resultData.data.pageLimit,
        };
      } else {
        // console.log("nnn");
        //防止token过期或者被清空
        if (resultData.data.code.toString() === "402" || !window.sessionStorage.getItem("token")) {
          message.warning("token过期,请重新登录", 1);
          window.location.hash = "/login";
        }
        // 状态码异常
        /* temp */
        if (resultData.data.text === messageInfo.msg1) {
          return;
        }
        if (flag && resultData.data.text === messageInfo.msg2) {
          return;
        }
        if (resultData.data.text) {
          message.warning(resultData.data.text, 1);
        }
        return {
          code: "no_data",
        };
      }
    } else {
      // console.log("bbb");
      // 接口返回异常
      if (resultData.data.text) {
        message.warning(resultData.data.text, 1);
      }
      return {
        code: "error",
        text: resultData.data.text,
      };
    }
  } catch (e) {
    // console.log("catch", e);
    // 请求失败
    message.warning(e.message);
    return {
      code: "fail",
    };
  }
};

export default FetchHandler;



// WEBPACK FOOTER //
// ./src/AntD/fetch/fetchHandler.js